

(function() {
	'use strict';
	angular.module('quantixApp').directive("toggleClass",
			[ '$document', '$parse','$timeout', function($document, $parse,$timeout) {
				return {
					link : function($scope, $element, $attributes) {
						var treediv = angular.element($element.children()[1]);


						  $(treediv).hide();
						$element.on('click', elementClick);

						 function elementClick(e) {
							e.stopPropagation();
							$timeout(function() {
								 var ip = treediv.find('input');
								 $(treediv).show();
								 $(ip).focus();

			                   },0);

				           }

						 function documentClick(e) {
							 $(treediv).hide();
				            }

						 $element.on('click', elementClick);
				            $document.on('click', documentClick);

				            $scope.$on('$destroy', function () {
				            	$element.off('click', elementClick);
				                $document.off('click', documentClick);
				            });


					}
				}
			} ]);




	angular.module('quantixApp').controller('SmeMarginController',
			SmeMarginController);

	SmeMarginController.$inject = [ '$scope', '$state', '$location',
			'GenericService', '$filter', 'SmeMarginsService', '$timeout',
			'AlertService', '$rootScope', 'ivhTreeviewMgr', 'ivhTreeviewBfs',
			'ivhTreeviewOptions', '$window', '$http', 'ErrorHandlerService',
			'SME_MARGIN','$anchorScroll' ];

	function SmeMarginController($scope, $state, $location, GenericService,
			$filter, SmeMarginsService, $timeout, AlertService, $rootScope,
			ivhTreeviewMgr, ivhTreeviewBfs, ivhTreeviewOptions, $window, $http,
			ErrorHandlerService, SME_MARGIN,$anchorScroll) {
		
		$anchorScroll();
		$rootScope.homePageMenuStatus = false;
		$rootScope.sme = true;
		$rootScope.home = false;
		$rootScope.bm = false;
		$rootScope.qst = false;
		$rootScope.score = false;
		$rootScope.fsm = false;
		$scope.totalCountOfReport=0;

		$("#industryModule").addClass("active");
		var opts = ivhTreeviewOptions(), isExpanded = opts.expandedAttribute;
		$scope.viewTreeIndustry = false;

		GenericService.getUserSectionAccessData().then(function(result){
			$scope.userSectionData = result;
			getOnloadData();
			$scope.getSelectedRange();
			$scope.getUserSubscription();
			populateCategories();
			
		});

		GenericService.getUserModuleAccessData().then(function(result){
			$scope.smemoduleaccess = result;
			if (!$scope.smemoduleaccess[SME_MARGIN]) {
				ErrorHandlerService.forbiddenError(SME_MARGIN);
				return;
			}
		});
		

		$('.toptabsec ul li a').click(function() {
			$('.toptabsec ul li a').removeClass("active");
			$(this).addClass("active");
		});

		var vm = this;

		$scope.industryall = false;
		$scope.selectAllflagprod = false;
		$scope.selectAllflagloc = false;

		$scope.novalue = false;
		$scope.nomarginetype = false;
		$scope.noYear = false;
		$scope.outOfRange = false;

		$scope.nosegdata = false;
		$scope.nolocdata = false;
		$scope.noinddata = false;
		$scope.tab = 1;
		vm.rangeToComapare = [];
		$scope.selectedsegmentsfinal = [];

		$scope.accrdn = {
			isopen : true
		};
		//$scope.accrdn.isopen = true;

		var currentdate = new Date();
		var prevyeardate = new Date();

		var lastdayarray = [];

		prevyeardate.setDate(currentdate.getDate() - 1280);

		var curryear = $filter('date')(currentdate, 'yyyy');
		var curryearint = parseInt(curryear);

		var prevyear = $filter('date')(prevyeardate, 'yyyy');
		var prevyearint = parseInt(prevyear);

		while (prevyearint <= curryearint) {

			var msec = Date.parse("March 31, " + prevyearint);

			lastdayarray.push(msec);
			prevyearint = prevyearint + 1;

		}

		var finalYearar = [];

		for (var i = 0; i < lastdayarray.length; i++) {

			if (prevyeardate.getTime() < lastdayarray[i]
					&& lastdayarray[i] < currentdate.getTime()) {

				var temp = new Date(lastdayarray[i]);
				var fy = $filter('date')(temp, 'yyyy');
				finalYearar.push(fy);
			}
		}

		finalYearar = finalYearar.slice(0, 3);
		finalYearar.sort(function(a, b) {
			return b - a
		});

		$scope.year = finalYearar[0];
		$scope.previousYearData = finalYearar[1];
		$scope.lastyearData = finalYearar[2];
		$scope.reseterrorflag = function(errorflag) {
			$scope.showResult = false;
			if (errorflag == 'outOfRange' && $scope.outOfRange) {
				$scope.outOfRange = false;
			}

			if (errorflag == 'nomarginetype' && $scope.nomarginetype) {
				$scope.nomarginetype = false;
			}
			if (errorflag == 'noYear' && $scope.noYear) {
				$scope.noYear = false;
			}
		}
		
		
		 $scope.gettooltipforIndustry = function (item, column) {
			 var html = "<label title='"+item.label+"'>"+item.label+"</label>"
			  return html;
		     };

		//ADDED FOR EXPORT
		$scope.dataToExport = null;
		$scope.generateExportExcel = function() {
			$scope.iferror = false;

			if($scope.userSectionData['SME Margin.Export SME'] != 'Y' )
				{
				$scope.errorMessages="You are not authorized to use the export feature. Please contact Administrator.";
				$scope.iferror=true;

				$scope.showResult = true;
				$scope.accrdn.isopen = true;


				}
			else
				{
				if ($scope.selectedType == 'INDUSTRY') {

					$scope.dataToSend = $scope.filterData;
					var urlexcel = 'api/smemargin/getdatasmeExportExcel';
					$http({
						url : urlexcel,

						method : 'POST',
						data : angular.toJson($scope.dataToSend),
						responseType : 'arraybuffer'

					})
							.success(
									function(response) {
										
									
										var isIE = false || !!document.documentMode;

										var blob = new Blob(
												[ response ],
												{
													type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
												});

										if (isIE) {

											window.navigator.msSaveOrOpenBlob(blob,
													'SME Margins results.xlsx');

										} else {
											var anchor = angular.element('<a/>');
											var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
											anchor.css({
											display : 'none'
											});
											// Make sure it's not visible
											angular.element(document.body).append(
											anchor); // Attach to document
											anchor
											.attr({
											href : objectUrl,
											target : '_blank',
											download : 'SME Margins results.xlsx'
											})[0].click();

											anchor.remove();

										}
									}).error(function(response) {
										
										$scope.iferror = true;
										$scope.errorMessages = "Error occured while exporting data to excel file. If problem persists, Please contact Administrator.";
										
										$scope.accrdn.isopen = true;
										
										$timeout(function() {

											$scope.iferror = false;
											$scope.errorMessages = "";

										}, 10000);
										
										return false;
										
									});

				} else if ($scope.selectedType == 'PRODUCT') {

					//$scope.dataToSend = $scope.dataToExportProd[0];
					$scope.dataToSend = $scope.filterData;
					var urlexcel = 'api/smemargin/getdatasmeExportExcelProd';
					$http({
						url : urlexcel,

						method : 'POST',
						data :angular.toJson($scope.dataToSend),
						
						responseType : 'arraybuffer'

					})
							.success(
									function(response) {
										var isIE = false || !!document.documentMode;

										var blob = new Blob(
												[ response ],
												{
													type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
												});

										if (isIE) {

											window.navigator.msSaveOrOpenBlob(blob,
													'SME Margins results.xlsx');

										} else {

											var anchor = angular.element('<a/>');
											var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
											anchor.css({
											display : 'none'
											});
											// Make sure it's not visible
											angular.element(document.body).append(
											anchor); // Attach to document
											anchor
											.attr({
											href : objectUrl,
											target : '_blank',
											download : 'SME Margins results.xlsx'
											})[0].click();

											anchor.remove();}

									}).error(function(response) {
										
										$scope.iferror = true;
									$scope.errorMessages = "Error occured while exporting data to excel file.If problem persists, Please contact Administrator.";
									
									$scope.accrdn.isopen = true;
									
									$timeout(function() {

										$scope.iferror = false;
										$scope.errorMessages = "";

									}, 10000);
									
									return false;
									})
									;
					}
				}
			}

		//END OF EXPORT

		$scope.Median = '';
		$scope.selectAllOrMedian = function(param) {
			$scope.showResult = false;
			$scope.novalue = false;
			if (param == 'Median') {
				$scope.Median = 'Median';
				$scope.filterData.op = 'Median';
			} else if (param == 'all') {
				$scope.Median = 'all';
				$scope.filterData.op = 'all';
			}
		}

		var grid = null;
		var netgrid = null;
		var prodgrid = null;
		var netprodgrid = null;
		var dat = null;
		var currentYear = '';
		var years = [];
		var col = [];

		currentYear = currentYear = parseInt(finalYearar[0]);


		$scope.ranges = [];
		$scope.locationName = '';
		$scope.chkval = true;
		var range = {
			'minValue' : '',
			'maxVvalue' : '',
			'val' : ''
		};

		$scope.smesegments = [];
		$scope.tradingId='';
		function getOnloadData() {

			var promise = GenericService.getZonalLocationDetailsdata();
			promise.then(function(data) {

				$scope.sampletreedata = data;
				$scope.gridOptionsSecLoc = {
					dataProvider : $scope.sampletreedata,
					delegate : $scope
				};
			}, function(error) {


				$scope.iferror = true;
				$scope.errorMessages = "Error Occured while loading location data, please try again. ";

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 10000);


			});

			SmeMarginsService.getsmesegmentData().then(function(response) {
				$scope.sampleSegmentdata = response.data;

				$scope.sampleSegmentdata.forEach(function(element) {
					var segprop='SME Margin.'+element.label+' Segment';

					if($scope.userSectionData[segprop] == 'Y')
						{
						element.enableflag='Y';
						}else
							{
							element.enableflag='N';
							}

				    if(element.label == 'Trading')
				    	{
				    	$scope.tradingId = element.id;
				    	}
				});
				}, function(errorresponse) {


				$scope.iferror = true;
				$scope.errorMessages = "Error Occured while loading segment data, please try again. ";

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 10000);


			});

			GenericService.getIndustryTreeDataModuleWise.getIndustryTree({
				moduleName : 'SME'
			}, function(data) {
				if (data[0] != null) {
					$scope.sampleIndustrydata = JSON.parse(data[0]);

					$scope.gridOptionsSec = {
						dataProvider : $scope.sampleIndustrydata,
						delegate : $scope
					};

				}else
					{
					$scope.iferror = true;
					$scope.errorMessages = "Error Occured while loading Industry data, please try again. ";

					$timeout(function() {

						$scope.iferror = false;
						$scope.errorMessages = "";

					}, 10000);
					}
			});


			var promise1 = GenericService.getMasterProductTreeData();
			promise1.then(function(data) {

				$scope.prodTreeData = data;

				$scope.gridOptionsSecProd = {
					dataProvider : $scope.prodTreeData,
					delegate : $scope
				};
			}, function(error) {


				$scope.iferror = true;
				$scope.errorMessages = "Error Occured while loading product data, please try again. ";

				$timeout(function() {

					$scope.iferror = false;
					$scope.errorMessages = "";

				}, 10000);


			});



		}
		var arrayind = new Array();
		var arrayprod = new Array();
		var arrayloc = new Array();

		var peerGroup1IndustryGrid = '';
		var peerGroup1ProductGrid = '';
		var peerGroup1LocationGrid = '';

		var peerGroup1IndustryGridKeys = null;
		var peerGroup1ProductGridKeys = null;
		var peerGroup1LocationGridKeys = null;

		var allKeysProducts = [];
		var allKeysInd = [];
		var allKeysLocations = [];

		$scope.selectedIndustries = [];
		$scope.selectedProducts = [];
		$scope.selectedLocations = [];

		var indgri = null;
		var prodgri = null;
		var locgri = null;

		$scope.badgeStringInd = '';
		$scope.badgeStringProd = '';
		$scope.badgeStringLoc = '';

		$scope.ind = {
			indstatus : false
		};
		$scope.prod = {
			prodstatus : false
		};
		$scope.loc = {
			locstatus : false
		};
		//$scope.indstatus = false;
		$scope.prodstatus = false;
		$scope.locstatus = false;
		var indfiltervaluchanged = false ;
		var firstcharind = '';

		$scope.filerPageSortHandle = function(event){
			  setTimeout(function () {
				  var filter = event.target.getRootFilter();
				  var grid = event.target;
				  if(!filter.filterExpressions.length){
					  grid.collapseAll();
		    		  grid.validateNow();
		    	//	  grid.rebuild();
		    		  indfiltervaluchanged = false ;


				  }
				  if(!indfiltervaluchanged)
			    	 {
			    	  if(event.cause == "filterChange"){
			    		  if(filter.filterExpressions && filter.filterExpressions.length){
			    			  firstcharind= filter.filterExpressions[0].expression
			    			  indfiltervaluchanged = true ;
				    		  $scope.onGridCreationCompletedIndustry(null);
				    		  }
			    	  }
			    	 } },1);
			};

			var prodfiltervaluchanged = false ;
			var firstcharprod = '';

			$scope.filerPageSortHandleprod = function(event){
				  setTimeout(function () {
					  var filter = event.target.getRootFilter();
					  var grid = event.target;
					  if(!filter.filterExpressions.length){
						  grid.collapseAll();
			    		  grid.validateNow();
			    		//  grid.rebuild();
			    		  prodfiltervaluchanged = false ;

					  }
					  if(!prodfiltervaluchanged)
				    	 {
				    	  if(event.cause == "filterChange"){
				    		  if(filter.filterExpressions && filter.filterExpressions.length){
				    			  firstcharprod= filter.filterExpressions[0].expression
				    			  prodfiltervaluchanged = true ;
					    		  $scope.onGridCreationCompletedProduct(null);
					    		  }
				    	  }
				    	 } },1);
				};

				var locfiltervaluchanged = false ;
				var firstcharloc = '';

				$scope.filerPageSortHandleloc = function(event){
					  setTimeout(function () {
						  var filter = event.target.getRootFilter();
						  var grid = event.target;
						  if(!filter.filterExpressions.length){
							  grid.collapseAll();
				    		  grid.validateNow();
				    		//  grid.rebuild();
				    		  locfiltervaluchanged = false ;

						  }
						  if(!locfiltervaluchanged)
					    	 {
					    	  if(event.cause == "filterChange"){
					    		  if(filter.filterExpressions && filter.filterExpressions.length){
					    			  firstcharloc= filter.filterExpressions[0].expression
					    			  locfiltervaluchanged = true ;
						    		  $scope.onGridCreationCompletedLocation(null);
						    		  }
					    	  }
					    	 } },1);
					};

		$scope.onDynamicLevelprodresultC = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = false;
			}
		};

		$scope.onDynamicLevelCind = function(event) {
			//alert("dynamic");

			event.level.setEnableFooters(false);

			if (event.level.getNestDepth() > 1) {

				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onDynamicLevelCprod = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};
		 $scope.gettooltipforProduct = function (item, column) {
			 var html = "<label title='"+item.label+"'>"+item.label+"</label>"
			  return html;
		     };
	
		     function  gettooltipforProductoutput(item, column) {
			    	
					 var html = "<label title='"+item.productName+"'>"+item.productName+"</label>"
					  return html;
				     };
		     
		     

		$scope.onDynamicLevelCloc = function(event) {
			event.level.setEnableFooters(false);
			if (event.level.getNestDepth() > 1) {
				event.level.forcePagerRow = false;
			} else {
				event.level.forcePagerRow = true;
			}
		};

		$scope.onGridCreationCompletedIndustry = function(event) {

			if(event != null)
				{
				indgri = event.target;
				indgri.enableHeightAutoAdjust = true;
				indgri.validateNow();

				}else
					{
					indgri.enableHeightAutoAdjust = true;
					indgri.clearFilter();
						indgri.expandAll();
						indgri.setFilterValue('label',firstcharind ,indgri);
						indgri.validateNow();
						}
			};

		$scope.onGridCreationCompletedProduct = function(event) {

			if(event != null)
				{
				prodgri = event.target;
				prodgri.enableHeightAutoAdjust = true;
				prodgri.validateNow();
				}else
					{
					prodgri.enableHeightAutoAdjust = true;
					prodgri.clearFilter();
					prodgri.expandAll();
					prodgri.setFilterValue('label',firstcharprod ,indgri);
					prodgri.validateNow();
						}
			};

		$scope.onGridCreationCompletedLocation = function(event) {

			if(event != null)
				{
				locgri = event.target;
				locgri.enableHeightAutoAdjust = true;
				locgri.validateNow();
				}else
					{
					locgri.enableHeightAutoAdjust = true;
					locgri.clearFilter();
					locgri.expandAll();
					locgri.setFilterValue('label',firstcharloc ,indgri);
					locgri.validateNow();
						}
			};

		var prodresultgrid = null;
		$scope.onProductGridCreationCompletedProduct = function(event) {
			prodresultgrid = event.target;
			prodresultgrid.enableHeightAutoAdjust = true;
			prodresultgrid.validateNow();

		};

		////adde for new tree
		var filterselectall = false;
		//for industry tree
		$scope.selectAllind = function(flag) {
			allKeysInd=[];
			if (flag) {
				$scope.noinddata = false;
				arrayind = [];
				$scope.selectedIndustries = [];
				if(indfiltervaluchanged)
					{
					filterselectall = true;
					$scope.industryall = false;
					}else
						{
						filterselectall = false;
						$scope.industryall = true;
						}


				ivhTreeviewBfs($scope.sampleIndustrydata, opts, function(node) {

					if(indfiltervaluchanged){

						if(node.label.toLowerCase().includes(firstcharind))
						{
						$scope.selectedIndustries.push(node.label);
							allKeysInd.push(node.id);

						if(node.children.length>0)
							{
							ivhTreeviewBfs(node, opts, function(childnode) {allKeysInd.push(childnode.id);});
							}

						}


					}else
						{
						allKeysInd.push(node.id);
						}

				});

				$scope.badgeStringInd = $scope.selectedIndustries.toString();

				$timeout(function() {
					indgri.setSelectedKeys(allKeysInd, false);
				}, 100);
				} else {
				arrayind = [];
				$scope.selectedIndustries = [];
				$scope.industryall = false;
				indgri.clearSelection();
				indgri.clearAllFilters();
				indgri.clearChanges();
				indfiltervaluchanged = false ;
				indgri.collapseAll();
				indgri.validateNow();
			//	indgri.rebuild();
				//alert($scope.selectedProducts);
			}
		}
		$scope.ind.indstatus = false;
		var cnt=0;

		$scope.setIndustryTree = function() {

			$scope.ind.indstatus = true;
			//$scope.showResult = false;


			$scope.gridOptionsSec = {
				dataProvider : $scope.sampleIndustrydata,
				delegate : $scope
			};


			if(cnt==0)
			{
				cnt=1;
				$timeout(function(){
				var l = document.getElementById('industryButton');
				l.click();
				}, 100, false);

				}
			}

		$scope.setbadgesforIndustry = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.noinddata = false;
				arrayind.push(evt.item.label);

			} else {
				if(arrayind.indexOf(evt.item.label) != -1)
					{
					arrayind.splice(arrayind.indexOf(evt.item.label), 1);
					}
				else if($scope.industryall)
					{
					$scope.industryall = false;
					arrayind = [];
					arrayind.push("Multiple Industries selected");
					}

				else if(indgri.getSelectedObjects().length > 1)
					{
					arrayind = [];
					arrayind.push("Multiple Industries selected");
					}else
						{
						arrayind = [];
						}
			}

			$timeout(function() {
				$scope.selectedIndustries = angular.copy(arrayind);
				$scope.badgeStringInd = $scope.selectedIndustries.toString();

				if($scope.badgeStringInd.length > 30){
					for (var i = 0; i < $scope.selectedIndustries.length; i++) {
						if ($scope.selectedIndustries[i].length > 10) {
							$scope.selectedIndustries[i] = $scope.selectedIndustries[i]
									.substr(0, 14)
									+ '..';
						}
					}
					$scope.badgeStringInd = $scope.selectedIndustries.toString();
				}
				else
					{
					$scope.badgeStringInd = $scope.selectedIndustries.toString();
					}
				}, 100);
			}

		//for product tree
		var filterselectallprod = false;
		$scope.selectAllprod = function(flag) {
			allKeysProducts=[];
			if (flag) {
				arrayprod = []
				$scope.selectedProducts = [];
				$scope.noinddata = false;


				if(prodfiltervaluchanged)
				{
					filterselectallprod = true;
				$scope.selectAllflagprod = false;
				}else
					{
					filterselectallprod = false;
					$scope.selectAllflagprod = true;
					}


				ivhTreeviewBfs($scope.prodTreeData, opts, function(node) {
					//allKeysProducts.push(node.id);
					if(prodfiltervaluchanged){

						if(node.label.toLowerCase().includes(firstcharprod))
						{
						$scope.selectedProducts.push(node.label);
						allKeysProducts.push(node.id);

						if(node.children.length>0)
							{
							ivhTreeviewBfs(node, opts, function(childnode) {allKeysProducts.push(childnode.id);});
							}

						}


					}else
						{
						allKeysProducts.push(node.id);
						}


				});
				$scope.badgeStringProd = $scope.selectedProducts.toString();
				$timeout(function() {
					prodgri.setSelectedKeys(allKeysProducts, false);
				}, 100);
				} else {
				arrayprod = [];
				$scope.selectedProducts = [];
				prodfiltervaluchanged = false ;
				$scope.selectAllflagprod = false;
				prodgri.clearSelection();
				prodgri.clearAllFilters();
				prodgri.collapseAll();
				prodgri.validateNow();
				}
		}
		var prodcnt=0;

		$scope.setProductTree = function() {

			$scope.prod.prodstatus = true;
			$scope.showResult = false;

			$scope.gridOptionsSecProd = {
				dataProvider : $scope.prodTreeData,
				delegate : $scope
			};

			if(prodcnt==0)
			{
				prodcnt=1;


			$timeout(function(){
				var l = document.getElementById('productButton');
				l.click();
				}, 100, false);


			}
			}




		var nodename = '';

		$scope.setbadgesforProduct = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				$scope.noinddata = false;
				arrayprod.push(evt.item.label);
			} else {
				if(arrayprod.indexOf(evt.item.label) != -1)
					{
					arrayprod.splice(arrayprod.indexOf(evt.item.label), 1);
					}
				else if($scope.selectAllflagprod)
					{
					$scope.selectAllflagprod = false;
					arrayprod = [];
					arrayprod.push("Multiple Products selected");
					}

				else if(prodgri.getSelectedObjects().length > 1)
					{
					arrayprod = [];
					arrayprod.push("Multiple Industries selected");
					}
				else
						{
						arrayprod = [];
						}

			}

			$timeout(function() {

				$scope.selectedProducts = angular.copy(arrayprod);
				$scope.badgeStringProd = $scope.selectedProducts.toString();
				if($scope.badgeStringProd.length > 30)
					{
					for (var i = 0; i < $scope.selectedProducts.length; i++) {
						if ($scope.selectedProducts[i].length > 15) {
							$scope.selectedProducts[i] = $scope.selectedProducts[i]
									.substr(0, 14)
									+ '..';
						}
					}
					$scope.badgeStringProd = $scope.selectedProducts.toString();
					}
				else
					{
					$scope.badgeStringProd = $scope.selectedProducts.toString();
					}


			}, 100);

		}

		//for locations
		var filterselectallloc = false;
		$scope.selectAllloc = function(flag) {
			allKeysLocations=[];
			if (flag) {
				arrayloc = []
				$scope.selectedLocations = [];
				$scope.nolocdata = false;

				if(locfiltervaluchanged)
				{
					filterselectallloc = true;
				$scope.selectAllflagloc = false;
				}else
					{
					filterselectallloc = false;
					$scope.selectAllflagloc = true;
					}

				ivhTreeviewBfs($scope.sampletreedata, opts, function(node) {
					//allKeysLocations.push(node.id);
					if(locfiltervaluchanged){

						if(node.label.toLowerCase().includes(firstcharloc))
						{
						$scope.selectedLocations.push(node.label);
						allKeysLocations.push(node.id);

						if(node.children)
							{
							ivhTreeviewBfs(node, opts, function(childnode) {allKeysLocations.push(childnode.id);});
							}

						}


					}else
						{
						allKeysLocations.push(node.id);
						}
				});
				$scope.badgeStringLoc = $scope.selectedLocations.toString();
				$timeout(function() {
					locgri.setSelectedKeys(allKeysLocations, false);
				}, 100);
				} else {
				arrayloc = [];
				$scope.selectedLocations = [];
				$scope.selectAllflagloc = false;
				locfiltervaluchanged = false ;
				locgri.clearSelection();
				locgri.clearAllFilters();
				locgri.collapseAll();
				locgri.validateNow();
				}
		}

		var loccnt=0;
		$scope.setLocationTree = function() {

			$scope.loc.locstatus = true;
			$scope.showResult = false;

			$scope.gridOptionsSecLoc = {
				dataProvider : $scope.sampletreedata,
				delegate : $scope
			};

			if(loccnt==0)
			{
				loccnt=1;
				$timeout(function(){
					var l = document.getElementById('locationButton');
					l.click();
					}, 100, false);

			}
			}

		$scope.setbadgesforLocation = function(evt) {

			var grid = evt.target;
			if (evt.isItemSelected) {
				arrayloc.push(evt.item.label);
				$scope.nolocdata = false;

			} else {
				if(arrayloc.indexOf(evt.item.label) != -1)
				{
					arrayloc.splice(arrayloc.indexOf(evt.item.label), 1);
				}
			else if($scope.selectAllflagloc)
				{
				$scope.selectAllflagloc = false;
				arrayloc = [];
				arrayloc.push("Multiple Locations selected");
				}

			else if(locgri.getSelectedObjects().length > 1)
				{
				arrayloc = [];
				arrayloc.push("Multiple Industries selected");
				}
			else
					{
				arrayloc = [];
					}
				}

			$timeout(function() {

				$scope.selectedLocations = angular.copy(arrayloc);
				$scope.badgeStringLoc = $scope.selectedLocations.toString();

				if($scope.badgeStringLoc.length > 30)
					{
					for (var i = 0; i < $scope.selectedLocations.length; i++) {
						if ($scope.selectedLocations[i].length > 10) {
							$scope.selectedLocations[i] = $scope.selectedLocations[i]
									.substr(0, 14)
									+ '..';
						}
					}
					$scope.badgeStringLoc = $scope.selectedLocations.toString();
					}
				else
					{
					$scope.badgeStringLoc = $scope.selectedLocations.toString();
					}
				}, 100);

		}

		$scope.selectedSegmnets = [];

		$scope.addtoselectedseg = function(chkval, segment) {
			$scope.showResult = false;
			if (chkval) {
				$scope.nosegdata = false;

				$scope.selectedsegmentsfinal.push(segment.id);
			} else {
				$scope.selectedsegmentsfinal.splice(
						$scope.selectedsegmentsfinal.indexOf(segment.id), 1);
			}

		}

		//end of adding for segment tree
		//end of adding

		$scope.gridOptionssmeOutputnetmargin = {
			dataProvider : [],
			styles : flexiciousNmsp.UIUtils.getThemeById('officeblue').styles,
			delegate : $scope
		};

		$scope.gridProductDatamargin = {
			dataProvider : [],
			styles : flexiciousNmsp.UIUtils.getThemeById('officeblue').styles,
			delegate : $scope
		};

		$scope.gridProductDataNetmargin = {
			dataProvider : [],
			styles : flexiciousNmsp.UIUtils.getThemeById('officeblue').styles,
			delegate : $scope
		};

		$scope.lastbucketflag=false;

		$scope.getSelectedRange = function() {

			if ($scope.userSectionData['SME Margin.SME Margin 0-25 Cr'] == 'Y') {

				var range = {
					'minValue' : '0',
					'maxVvalue' : '25',
					'val' : 'Upto 25'
				}
				$scope.ranges.push(range);

			}
			if ($scope.userSectionData['SME Margin.SME Margin 25 - 50 Cr'] == 'Y') {

				var range = {
					'minValue' : '25',
					'maxVvalue' : '50',
					'val' : '>25-50'
				}
				$scope.ranges.push(range);

			}
			if ($scope.userSectionData['SME Margin.SME Margin 50 - 100 Cr'] == 'Y') {

				var range = {
					'minValue' : '50',
					'maxVvalue' : '100',
					'val' : '>50-100'
				}
				$scope.ranges.push(range);

			}

			if ($scope.userSectionData['SME Margin.SME Margin 100 - 250 Cr'] == 'Y') {

				var range = {
					'minValue' : '100',
					'maxVvalue' : '250',
					'val' : '>100-250'
				}
				$scope.ranges.push(range);

			}

			if ($scope.userSectionData['SME Margin.SME Margin  250 Cr & above'] == 'Y') {

				$scope.lastbucketflag=true;
				var range = {
					'minValue' : '250',
					'maxVvalue' : '100000',
					'val' : 'Above 250'
				}
				$scope.ranges.push(range);
			}

			$scope.creditRatingRanges = $scope.ranges;
			$scope.creditRatingRangesnew = $scope.creditRatingRanges;

			vm.cflag = false;
			vm.minValueforcrange = 0;
			vm.maxValueforcrange = 0;
			vm.range = {
				'minValue' : '',
				'maxVvalue' : ''
			};

			vm.rangeToComapare = new Array();

			if ($scope.creditRatingRanges.length != 1) {
				var j = 0;
				vm.cflag = false;
				vm.minValueforcrange = 0;
				vm.maxValueforcrange = 0;
				var started = 0;
				var comeOut = false;
				vm.range = {
					'minValue' : '',
					'maxVvalue' : ''
				};
				while (j < $scope.creditRatingRanges.length) {


					if (j < $scope.creditRatingRanges.length - 1) {

						while (!comeOut
								&& ($scope.creditRatingRanges[j].maxVvalue == $scope.creditRatingRanges[j + 1].minValue || $scope.creditRatingRanges[j].maxVvalue == $scope.creditRatingRanges[j + 1].minValue - 1)) {

							if (started == 0) {
								started = 1;
								vm.minValueforcrange = $scope.creditRatingRanges[j].minValue;
							}

							vm.maxValueforcrange = $scope.creditRatingRanges[j + 1].maxVvalue;
							j = j + 1;

							if (j >= $scope.creditRatingRanges.length - 1) {

								comeOut = true;

							}
						}
					}else
						{
						
						started = 0;
						
						}


					if (started == 1) {
						vm.range = {
							'minValue' : vm.minValueforcrange,
							'maxVvalue' : vm.maxValueforcrange
						};

					} else if (started == 0) {
						vm.minValueforcrange = $scope.creditRatingRanges[j].minValue;
						vm.maxValueforcrange = $scope.creditRatingRanges[j].maxVvalue;

						vm.range = {
							'minValue' : vm.minValueforcrange,
							'maxVvalue' : vm.maxValueforcrange
						};
						started = 0;
						}

					vm.rangeToComapare.push(vm.range);
					j = j + 1;
				}
			} else if ($scope.creditRatingRanges.length == 1) {
				vm.minValueforcrange = $scope.creditRatingRanges[0].minValue;
				vm.maxValueforcrange = $scope.creditRatingRanges[0].maxVvalue;

				vm.range = {
					'minValue' : vm.minValueforcrange,
					'maxVvalue' : vm.maxValueforcrange
				};
				vm.rangeToComapare.push(vm.range);
			}

			$scope.creditRatingRanges = [];
			$scope.creditRatingRanges = vm.rangeToComapare;


		}

		$scope.allBenchmarkSubscription = [ {

			value : 'Upto 25',
			isAvailable : false
		}, {
			value : '>25-50',
			isAvailable : false
		}, {
			value : '>50-100',
			isAvailable : false
		}, {
			value : '>100-250',
			isAvailable : false
		}]


		$scope.getUserSubscription = function() {
			angular.forEach($scope.allBenchmarkSubscription, function(allRange,
					allkey) {
				angular.forEach($scope.creditRatingRangesnew, function(
						availableRange, availablekey) {
					if (allRange.value == availableRange.val) {
						allRange.isAvailable = true;
					}
				});

			});


		}
		function populateCategories() {
			$scope.categories = [];
			if ($scope.userSectionData['SME Margin.SME Margin for 3 years'] == 'Y') {

				$scope.categories = [{

					"name": $scope.year,
					"id": $scope.year,
					"flg": 'Y'
				}, {
					"name": $scope.previousYearData,
					"id": $scope.previousYearData,
					"flg": 'Y'
				}, {
					"name": $scope.lastyearData,
					"id": $scope.lastyearData,
					"flg": 'Y'
				}];
			}

			else if ($scope.userSectionData['SME Margin.SME Margin for 2 years'] == 'Y') {

				$scope.categories = [{

					"name": $scope.year,
					"id": $scope.year,
					"flg": 'Y'
				}, {
					"name": $scope.previousYearData,
					"id": $scope.previousYearData,
					"flg": 'Y'
				}, {
					"name": $scope.lastyearData,
					"id": $scope.lastyearData,
					"flg": 'N'
				}];
			}

			else if ($scope.userSectionData['SME Margin.SME Margin for latest year'] == 'Y') {

				$scope.categories = [{

					"name": $scope.year,
					"id": $scope.year,
					"flg": 'Y'
				}, {
					"name": $scope.previousYearData,
					"id": $scope.previousYearData,
					"flg": 'N'
				}, {
					"name": $scope.lastyearData,
					"id": $scope.lastyearData,
					"flg": 'N'
				}];
			}
		}
	
		var yearObject = {};
		yearObject[currentYear] = false;
		$scope.filterData = {
			operatingMargin : false,
			netMargin : false,
			Median : false
		};

		$scope.filterData["ids"] = yearObject;

		$scope.selectedType = 'INDUSTRY';

		$scope.status = {
			open : true
		};

		$scope.setSelectedType = function(type) {
			$scope.showResult = false;
			
			if ($scope.selectedType != type) {
				if (type == 'INDUSTRY') {
					if (prodgri != null) {
						prodgri.clearSelection();
						$scope.selectedProducts = [];
						$scope.selectAllprodflag = false;
						allKeysProducts = [];
						allKeysInd = [];
						arrayind = new Array();
						arrayprod = new Array();
					}
				} else if (type == "PRODUCT") {
					if (indgri != null) {
						indgri.clearSelection();
						allKeysProducts = [];
						allKeysInd = [];
						$scope.selectedIndustries = [];
						$scope.industryall = false;
						arrayind = new Array();
						arrayprod = new Array();
					}
				}

				$scope.selectedType = type;
			}


		}
		$scope.selectedranges = [];
		$scope.setlimit = function(selectedRange) {

			$scope.selectedranges = selectedRange;

		}

		$scope.showResult = false;

		$scope.getsearchData = function() {

			$scope.filterData.selectedType = $scope.selectedType;
			var locationids = [];
			$scope.filterData.AlllocSelected = $scope.selectAllflagloc;
			if ((locgri != null && locgri != ""  &&  !$scope.filterData.AlllocSelected && filterselectallloc)||
					(locgri != null && locgri != ""  &&  !$scope.filterData.AlllocSelected )) {
				peerGroup1LocationGridKeys = locgri.getSelectedObjects();

					ivhTreeviewBfs(peerGroup1LocationGridKeys, opts, function(node) {
						if(!node.children)
							{
							if(locationids.indexOf(node.id) == -1)
							{
							locationids.push(node.id);
							}
							}
						});
					}


			$scope.filterData.locationIds = locationids
					.toString();



			if ($scope.selectedType == 'INDUSTRY') {

				$scope.filterData.AllIndSelected = $scope.industryall;
				var industryids = [];

				if ((indgri != null && indgri != "" && !$scope.filterData.AllIndSelected && filterselectall )||
						(indgri != null && indgri != "" && !$scope.filterData.AllIndSelected  )) {
					peerGroup1IndustryGridKeys = indgri.getSelectedObjects();

					ivhTreeviewBfs(peerGroup1IndustryGridKeys, opts, function(node) {
						if(node.children.length==0)
							{
							if(industryids.indexOf(node.id) == -1)
							{
								industryids.push(node.id);
							}
							}
						});
					}

				$scope.filterData.industryids = industryids.toString();
			} else {
				var productids = [];
				$scope.filterData.AllIndSelected = $scope.selectAllflagprod;
				//alert(prodgri.getSelectedKeys().length);
				if ((prodgri != null && prodgri != "" && !$scope.filterData.AllIndSelected && filterselectallprod)||
						(prodgri != null && prodgri != "" && !$scope.filterData.AllIndSelected )) {
					peerGroup1ProductGridKeys = prodgri.getSelectedObjects();

					ivhTreeviewBfs(peerGroup1ProductGridKeys, opts, function(node) {
						if(node.children.length==0)
							{
							if(productids.indexOf(node.id) == -1)
							{
								productids.push(node.id);
							}
							}
						});
					}

				$scope.filterData.industryids = productids
						.toString();

				$scope.nosegdata = false;


			}

			if ($scope.selectedsegmentsfinal.length == 0) {

				if ($scope.selectedType == 'PRODUCT') {
					$scope.nosegdata = false;
				} else {
					$scope.nosegdata = true;
				}
				} else {
				$scope.filterData.selectedSegments = $scope.selectedsegmentsfinal
						.toString();

				$scope.filterData.tradingId = $scope.tradingId;
			}

			$scope.outOfRange = false;
			var comp = 0;
			var withingRange = false;
			while (comp <= vm.rangeToComapare.length - 1) {
				if (parseInt($scope.filterData.salesTurnoverFrom) >= vm.rangeToComapare[comp].minValue
						&& parseInt($scope.filterData.salesTurnoverTo) <= vm.rangeToComapare[comp].maxVvalue) {
					withingRange = true;
				}
				comp = comp + 1;

			}
			if (withingRange != true) {
				//	alert("values not within range");
				AlertService
						.error("Please enter SalesTurnover from and to values within range.");

				$scope.outOfRange = true;

				//	return false;
			}

			if (parseInt($scope.filterData.salesTurnoverFrom) > parseInt($scope.filterData.salesTurnoverTo)) {
				AlertService
						.error("Please enter from value greater than to value.");
				$scope.outOfRange = true;
				//	return false;
			}
			$scope.opt = $scope.filterData.operatingMargin;
			$scope.net = $scope.filterData.netMargin;
			$scope.filterData.type = $scope.selectedType;
			$scope.locationnameinop = '';
			if ($scope.selectAllflagloc) {
				$scope.locationName = 'PAN India';
				$scope.locationnameinop = 'PAN India';
			} else if ($scope.selectedLocations.length > 1) {
				$scope.locationName = 'Multiple District'; // ('
						//+ $scope.filterData.locationIds + ')';    //Modified By Tejal for Bug id: 58362
				$scope.locationnameinop = 'Multiple District';
			} else if ($scope.selectedLocations.length == 1) {
				$scope.locationName = $scope.selectedLocations[0];
				$scope.locationnameinop = $scope.locationName;
			}
			$scope.filterData.locationName = $scope.locationName;

			$scope.filterData.YearsArray = [];
			angular.forEach($scope.categories, function(category) {
				if (!!$scope.filterData.ids[category.id])
					$scope.filterData.YearsArray.push(category.id);
			});
			years = $scope.filterData.YearsArray
			$scope.filterData.YearsArray = $scope.filterData.YearsArray + "";

			if ($scope.filterData.industryids == null
					|| $scope.filterData.industryids == "null"
					|| typeof $scope.filterData.industryids == "undefined"
					|| $scope.filterData.industryids.length == "" &&  !$scope.filterData.AllIndSelected) {
				AlertService
						.error("Please select atleast one Industry or Segment");

				$scope.noinddata = true;

				//return false;
			}
			if ($scope.filterData.locationIds == null
					|| $scope.filterData.locationIds == "null"
					|| typeof $scope.filterData.locationIds == "undefined"
					|| $scope.filterData.locationIds.length == "" && !$scope.filterData.AlllocSelected) {
				AlertService.error("Please select atleast one Location");
				$scope.nolocdata = true;
				//	return false;
			}
			if ($scope.filterData.salesTurnoverFrom == null
					|| $scope.filterData.salesTurnoverFrom == "null"
					|| $scope.filterData.salesTurnoverTo == null
					|| $scope.filterData.salesTurnoverTo == "null") {
				AlertService
						.error("Please enter SalesTurnover from and to values.");
				$scope.outOfRange = true;
				//return false;
			}

			if ($scope.Median == '') {
				AlertService.error("Please enter Proper Value.");
				$scope.novalue = true;
				//	return false;
			}
			if ($scope.filterData.YearsArray.length == 0) {
				AlertService.error("Please enter Proper Value of year.");
				$scope.noYear = true;
				//	return false;
			}
			if ($scope.filterData.operatingMargin == false
					&& $scope.filterData.netMargin == false) {
				AlertService
						.error("Please enter Proper Value of operating and net margin.");
				$scope.nomarginetype = true;
				//	return false;
			}

			if (($scope.novalue || $scope.nomarginetype || $scope.noYear
					|| $scope.outOfRange || $scope.nosegdata
					|| $scope.nolocdata || $scope.noinddata)) {
				return false;
			}
		
			SmeMarginsService
					.getsmeData($scope.filterData)
					.then(
							function(response) {
								GenericService.trackUsage(new Date(),'SME MARGINS');
								dat = response;

								$scope.dataToExport = dat.exportData;

								$scope.printOpMar = dat.operatingMargin;
								$scope.printNeMar = dat.netMargin;
								if ($scope.selectedType == 'INDUSTRY') {

									if (($scope.printOpMar == null
											|| $scope.printOpMar.length == 0) && ( $scope.printNeMar == null
											|| $scope.printNeMar.length == 0)) {

										$scope.iferror = true;
										$scope.errorMessages = "No records found for this criterion. Please change / broaden your selection.";

										$timeout(function() {

											$scope.iferror = false;
											$scope.errorMessages = "";

										}, 10000);

										$scope.showResult = false;
										$scope.accrdn.isopen = true;

										return false;
									} else {

										if($scope.printOpMar.length == 0 ){
											$scope.tab=2;
										}
										else{
											$scope.tab=1;
										}

										$scope.showResult = true;
										$timeout(function() {

											$scope.accrdn.isopen = false;

										}, 10);

									}
								} else {

									$scope.printProddata = dat.productData;
									$scope.dataToExportProd = dat.exportDataProd;

									if ($scope.printProddata == null
											|| $scope.printProddata.length == 0) {

										$scope.iferror = true;
										$scope.errorMessages = "No records found for this criterion. Please change / broaden your selection.";

										$timeout(function() {

											$scope.iferror = false;
											$scope.errorMessages = "";

										}, 10000);

										$scope.showResult = false;
										$scope.accrdn.isopen = true;

										return false;
									} else {

										$scope.showResult = true;
										$timeout(function() {

											$scope.accrdn.isopen = false;

										}, 10);

									}
								}

								if (typeof $scope.filterData.operatingMargin != 'undefined'
										&& ($scope.filterData.operatingMargin == "true" || $scope.filterData.operatingMargin == true)) {

									if ($scope.selectedType == 'INDUSTRY') {
										$scope.gridOptionssmeOutput = {
											dataProvider : dat.operatingMargin,
											styles : flexiciousNmsp.UIUtils
													.getThemeById('officeblue').styles,
											delegate : $scope
										};

										if (grid != null) {
											
											$scope.buildGridoperatingMargin();
											
										}
										if($scope.filterData.operatingMargin)
										{
											$scope.setTab(1);
										}

									} else {
										$scope.printProddataop = dat.productDataop;
										
										
										
										if($scope.printProddataop.length == 0)
											{
											$scope.iferror = true;
											$scope.errorMessages = "No records found for this criterion. Please change / broaden your selection.";

											$timeout(function() {

												$scope.iferror = false;
												$scope.errorMessages = "";

											}, 10000);

											$timeout(function() {
												$scope.showResult = false;
												$scope.accrdn.isopen = true;

											}, 10);
											
											return false;
											}
										else
											{
											$scope.gridProductDatamargin = {
													dataProvider : $scope.printProddataop,
													styles : flexiciousNmsp.UIUtils
															.getThemeById('officeblue').styles,
													delegate : $scope
												};

												if (prodgrid != null) {
													$scope.buildOperatingGridProduct();
													if($scope.filterData.operatingMargin)
													{
														$scope.setTab(1);
													}
												}
											}
										

									}

								}

								if (typeof $scope.filterData.netMargin != 'undefined'
										&& ($scope.filterData.netMargin == "true" || $scope.filterData.netMargin == true)) {

									if ($scope.selectedType == 'INDUSTRY') {
										$scope.gridOptionssmeOutputnetmargin = {
											dataProvider : dat.netMargin,
											styles : flexiciousNmsp.UIUtils
													.getThemeById('officeblue').styles,
											delegate : $scope
										};

										if (netgrid != null) {
											$scope.buildGridnetMargin();
											if($scope.filterData.netMargin && !$scope.filterData.operatingMargin )
											{
											$scope.setTab(2);
											}
										}
									} else {
										$scope.printProddatanp = dat.productDatanp;
										
										/*$scope.printProddata = $scope.printProddata
										.filter(function(row) {
											return (row.validnpflag);
										});
										
										for(var obj in $scope.printProddata)
											{
											if($scope.printProddata[obj].childProductList != undefined || $scope.printProddata[obj].childProductList != null)
												{
												for(var i = 0;i<$scope.printProddata[obj].childProductList.length ;i++)
													{
													if(!$scope.printProddata[obj].childProductList[i].validnpflag)
														{
														$scope.printProddata[obj].childProductList.splice
														($scope.printProddata[obj].childProductList.indexOf($scope.printProddata[obj].childProductList[i]),1);
														}
													}
												}
											}*/
										
										if($scope.printProddatanp.length == 0)
										{
										$scope.iferror = true;
										$scope.errorMessages = "No records found for this criterion. Please change / broaden your selection.";

										$timeout(function() {

											$scope.iferror = false;
											$scope.errorMessages = "";

										}, 10000);

										
										$timeout(function() {
											$scope.showResult = false;
											$scope.accrdn.isopen = true;

										}, 10);
										
										
										return false;
										}else
											{

											$scope.gridProductDataNetmargin = {
												dataProvider : $scope.printProddatanp,
												styles : flexiciousNmsp.UIUtils
														.getThemeById('officeblue').styles,
												delegate : $scope
											};

											if (netprodgrid != null) {
												$scope.buildNetGridProduct();
												
												if($scope.filterData.netMargin && !$scope.filterData.operatingMargin)
													{
													$scope.setTab(2);
													}
											}
											}


									}

								}
							},
							function(errorresponse) {

								$scope.iferror = true;
								$scope.errorMessages = "An error occured while getting output data. If problem persists, please contact Administrator.";

								$timeout(function() {

									$scope.iferror = false;
									$scope.errorMessages = "";

								}, 10000);

								$scope.showResult = false;
								$scope.accrdn.isopen = true;

								return false;

							});

		}
		
		$scope.dynamicColumns_productgrid_creationCompleteHandler = function(
				evt) {

			prodgrid = evt.target;
			$scope.buildOperatingGridProduct();

			prodgrid.excelOptions.enableLocalFilePersistence = false;
		};

		$scope.dynamicColumns_netproductgrid_creationCompleteHandler = function(
				evt) {

			netprodgrid = evt.target;
			//	$scope.buildNetGridProduct();

		};

		$scope.dynamicColumns_grid_creationCompleteHandler = function(evt) {

			grid = evt.target;
			$scope.buildGridoperatingMargin();

			grid.excelOptions.enableLocalFilePersistence = false;
		};
		$scope.dynamicColumns_grid_creationCompleteHandlernetmargin = function(
				evt) {

			netgrid = evt.target;
			//	$scope.buildGridnetMargin();
		};
		
		$scope.buildNetGridProduct = function() {

			//gridProductDatamargin'

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);

			var gridforoperatingmargin = "Net Margin - Range :"
					+ $scope.filterData.salesTurnoverFrom + "-"
					+ $scope.filterData.salesTurnoverTo + " Crore , "
					+ $scope.locationnameinop;

			ycgmain.setHeaderText(gridforoperatingmargin);
			//	ycgmain.height = 30;

			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();

			if ($scope.selectedType == 'PRODUCT') {
				mCol1.setHeaderText("NIC Code");
				mCol1.setDataField(('productCode') + "");
			} else {
				mCol1.setHeaderText("Industry");
				mCol1.setDataField(('productName') + "");
			}
			mCol1.setStyle("textAlign", "center");
			mCol1.enableHierarchicalNestIndent = "true";
			//	mCol1.setDataField("1");
			//('ind_name') + "";
			//mCol1.setDataField(('productCode') + "");
			mCol1.headerAlign = "center";
			//mCol1.setColumnWidthMode("fitToContent");
			
			if($scope.Median != "all" && years.length == 1)
			{
				mCol1.setColumnWidthMode= "fixed";
				mCol1.Width="400";
			
			}else
				{
				mCol1.setColumnWidthMode("fitToContent");
				}
			
			//	mCol1.setWidth(65);
			allheadCols.push(mCol1);

			if ($scope.selectedType == 'PRODUCT') {
				mCol.setHeaderText("Product");
				mCol.setDataField(('productName') + "");
			} else {
				mCol.setHeaderText("Segment");
				mCol.setDataField(('productCode') + "");
			}

			//mCol.setDataField(('productName') + "");
			mCol.headerAlign = "center";
			//	mCol.setColumnWidthMode("fitToContent");
			
			mCol.setStyle("textAlign", "left");
			mCol.enableHierarchicalNestIndent = "true";
			mCol.setLabelFunction(gettooltipforProductoutput);
			
			if($scope.Median != "all" && years.length == 1)
			{
				mCol.setColumnWidthMode= "fixed";
				mCol.Width="400";
			
			}else
				{
				mCol.setColumnWidthMode("fixed");
				mCol.setWidth(200);
				}
			
			
			//mCol.setWidth(550);
			allheadCols.push(mCol);
			ycgmain.setColumns(allheadCols);
			if (years.length == 3) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");
					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.enableHierarchicalNestIndent = true;
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//mCol4.setDataField(('opMaxlatestyear') + "");
					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}
					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//	mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol6 = new flexiciousNmsp.FlexDataGridColumn();
					mCol6.setHeaderText('Median');
					//mCol6.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol6.setDataField(('opmedin2year') + "");
					} else {
						mCol6.setDataField(('npmedin2year') + "");
					}

					mCol6.setStyle("textAlign", "right");
					mCol6.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol6.columnWidthMode = "fixed";
					mCol6.Width = "90";
					allCols.push(mCol6);

					var mCol7 = new flexiciousNmsp.FlexDataGridColumn();
					mCol7.setHeaderText('Maximum');
					//mCol7.setDataField(('opMax2year') + "");
					if ($scope.tab == 1) {
						mCol7.setDataField(('opMax2year') + "");
					} else {
						mCol7.setDataField(('npMax2year') + "");
					}

					mCol7.setStyle("textAlign", "right");
					mCol7.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol7.columnWidthMode = "fixed";
					mCol7.Width = "90";
					allCols.push(mCol7);

					var mCol8 = new flexiciousNmsp.FlexDataGridColumn();
					mCol8.setHeaderText('Minimum');
					//	mCol8.setDataField(('opMin2tyear') + "");

					if ($scope.tab == 1) {
						mCol8.setDataField(('opMin2tyear') + "");
					} else {
						mCol8.setDataField(('npMin2tyear') + "");
					}

					mCol8.setStyle("textAlign", "right");
					mCol8.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol8.columnWidthMode = "fixed";
					mCol8.Width = "90";
					allCols.push(mCol8);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[2] + " (%)");

					var mCol9 = new flexiciousNmsp.FlexDataGridColumn();
					mCol9.setHeaderText('Median');
					//mCol9.setDataField(('opmedian3year') + "");

					if ($scope.tab == 1) {
						mCol9.setDataField(('opmedian3year') + "");
					} else {
						mCol9.setDataField(('npmedian3year') + "");
					}

					mCol9.setStyle("textAlign", "right");
					mCol9.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol9.columnWidthMode = "fixed";
					mCol9.Width = "90";
					allCols.push(mCol9);

					var mCol10 = new flexiciousNmsp.FlexDataGridColumn();
					mCol10.setHeaderText('Maximum');
					//mCol10.setDataField(('opMax3year') + "");
					if ($scope.tab == 1) {
						mCol10.setDataField(('opMax3year') + "");
					} else {
						mCol10.setDataField(('npMax3year') + "");
					}

					mCol10.setStyle("textAlign", "right");
					mCol10.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol10.columnWidthMode = "fixed";
					mCol10.Width = "90";
					allCols.push(mCol10);

					var mCol11 = new flexiciousNmsp.FlexDataGridColumn();
					mCol11.setHeaderText('Minimum');
					//mCol11.setDataField(('opMin3tyear') + "");
					if ($scope.tab == 1) {
						mCol11.setDataField(('opMin3tyear') + "");
					} else {
						mCol11.setDataField(('npMin3tyear') + "");
					}

					mCol11.setStyle("textAlign", "right");
					mCol11.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol11.columnWidthMode = "fixed";
					mCol11.Width = "90";

					allCols.push(mCol11);
					ycg.setColumns(allCols);

				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//	mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Median');
					//	mCol4.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opmedin2year') + "");
					} else {
						mCol4.setDataField(('npmedin2year') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[2] + " (%)");

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Median');
					//	mCol5.setDataField(('opmedian3year') + "");
					if ($scope.tab == 1) {
						mCol5.setDataField(('opmedian3year') + "");
					} else {
						mCol5.setDataField(('npmedian3year') + "");
					}
					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);
				}

			}

			if (years.length == 2) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");
					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//mCol3.setDataField(('opmedianlatestyear') + "");

					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//mCol4.setDataField(('opMaxlatestyear') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol6 = new flexiciousNmsp.FlexDataGridColumn();
					mCol6.setHeaderText('Median');
					//	mCol6.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol6.setDataField(('opmedin2year') + "");
					} else {
						mCol6.setDataField(('npmedin2year') + "");
					}

					mCol6.setStyle("textAlign", "right");
					mCol6.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol6.columnWidthMode = "fixed";
					mCol6.Width = "90";
					allCols.push(mCol6);

					var mCol7 = new flexiciousNmsp.FlexDataGridColumn();
					mCol7.setHeaderText('Maximum');
					//	mCol7.setDataField(('opMax2year') + "");

					if ($scope.tab == 1) {
						mCol7.setDataField(('opMax2year') + "");
					} else {
						mCol7.setDataField(('npMax2year') + "");
					}

					mCol7.setStyle("textAlign", "right");
					mCol7.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol7.columnWidthMode = "fixed";
					mCol7.Width = "90";
					allCols.push(mCol7);

					var mCol8 = new flexiciousNmsp.FlexDataGridColumn();
					mCol8.setHeaderText('Minimum');
					//	mCol8.setDataField(('opMin2tyear') + "");
					if ($scope.tab == 1) {
						mCol8.setDataField(('opMin2tyear') + "");
					} else {
						mCol8.setDataField(('npMin2tyear') + "");
					}

					mCol8.setStyle("textAlign", "right");
					mCol8.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol8.columnWidthMode = "fixed";
					mCol8.Width = "90";
					allCols.push(mCol8);
					ycg.setColumns(allCols);
				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//		mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Median');
					//	mCol4.setDataField(('opmedin2year') + "");
					if ($scope.tab == 1) {
						mCol4.setDataField(('opmedin2year') + "");
					} else {
						mCol4.setDataField(('npmedin2year') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);
					ycg.setColumns(allCols);
				}

			}
			if (years.length == 1) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//	mCol4.setDataField(('opMaxlatestyear') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);
				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//	mCol3.setDataField(('opmedianlatestyear') + "");

					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					
						if($scope.Median != "all" && years.length == 1)
						{
							mCol3.setStyle("textAlign", "center");
						}else
							{
							mCol3.setStyle("textAlign", "right");
							}
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

				}

			}
			netprodgrid.getColumnLevel().setGroupedColumns(gridCgs);

			netprodgrid.rebuild();
			$timeout(function() {
				netprodgrid.expandAll();
			}, 10);

			netprodgrid.validateNow();
			netprodgrid.expandAll();

		}

		$scope.buildOperatingGridProduct = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);

			var gridforoperatingmargin = "Operating Income - Range :"
					+ $scope.filterData.salesTurnoverFrom + "-"
					+ $scope.filterData.salesTurnoverTo + " Crore , "
					+ $scope.locationnameinop;

			ycgmain.setHeaderText(gridforoperatingmargin);
			//	ycgmain.height = 30;

			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();

			if ($scope.selectedType == 'PRODUCT') {
				mCol1.setHeaderText("NIC Code");
				mCol1.setDataField(('productCode') + "");
				
			} else {
				mCol1.setHeaderText("Industry");
				mCol1.setDataField(('productName') + "");
			}
			mCol1.headerAlign = "center";
			
			mCol1.setStyle("textAlign", "center");
			mCol1.enableHierarchicalNestIndent = "true";
			//	mCol1.xienableExpandCollapseIcon="true"
			//mCol1.setColumnWidthMode("fitToContent");
			
			if($scope.Median != "all" && years.length == 1)
			{
				mCol1.setColumnWidthMode= "fixed";
				mCol1.Width="400";
			
			}else
				{
				mCol1.setColumnWidthMode("fitToContent");
				}
			
			
			//	mCol1.setWidth(65);
			allheadCols.push(mCol1);

			if ($scope.selectedType == 'PRODUCT') {
				mCol.setHeaderText("Product");
				mCol.setDataField(('productName') + "");
			} else {
				mCol.setHeaderText("Segment");
				mCol.setDataField(('productCode') + "");
			}
			mCol.setLabelFunction(gettooltipforProductoutput);
			//mCol.setDataField(('productName') + "");
			mCol.headerAlign = "center";
			//	mCol.setColumnWidthMode("fitToContent");
			//	mCol.paddingLeft="20";
			mCol.setStyle("textAlign", "left");
			mCol.enableHierarchicalNestIndent = "true";
			//mCol.xienableExpandCollapseIcon="true"
		//	mCol.setColumnWidthMode("fixed");
		//	mCol.setWidth(200);
			if($scope.Median != "all" && years.length == 1)
			{
				mCol.setColumnWidthMode= "fixed";
				mCol.Width="400";
			
			}else
				{
				mCol.setColumnWidthMode("fixed");
					mCol.setWidth(200);
				}
			
			
			//mCol.setWidth(550);
			allheadCols.push(mCol);
			ycgmain.setColumns(allheadCols);

			if (years.length == 3) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");
					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.enableHierarchicalNestIndent = true;
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//mCol4.setDataField(('opMaxlatestyear') + "");
					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}
					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//	mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol6 = new flexiciousNmsp.FlexDataGridColumn();
					mCol6.setHeaderText('Median');
					//mCol6.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol6.setDataField(('opmedin2year') + "");
					} else {
						mCol6.setDataField(('npmedin2year') + "");
					}

					mCol6.setStyle("textAlign", "right");
					mCol6.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol6.columnWidthMode = "fixed";
					mCol6.Width = "90";
					allCols.push(mCol6);

					var mCol7 = new flexiciousNmsp.FlexDataGridColumn();
					mCol7.setHeaderText('Maximum');
					//mCol7.setDataField(('opMax2year') + "");
					if ($scope.tab == 1) {
						mCol7.setDataField(('opMax2year') + "");
					} else {
						mCol7.setDataField(('npMax2year') + "");
					}

					mCol7.setStyle("textAlign", "right");
					mCol7.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol7.columnWidthMode = "fixed";
					mCol7.Width = "90";
					allCols.push(mCol7);

					var mCol8 = new flexiciousNmsp.FlexDataGridColumn();
					mCol8.setHeaderText('Minimum');
					//	mCol8.setDataField(('opMin2tyear') + "");

					if ($scope.tab == 1) {
						mCol8.setDataField(('opMin2tyear') + "");
					} else {
						mCol8.setDataField(('npMin2tyear') + "");
					}

					mCol8.setStyle("textAlign", "right");
					mCol8.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol8.columnWidthMode = "fixed";
					mCol8.Width = "90";
					allCols.push(mCol8);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[2] + " (%)");

					var mCol9 = new flexiciousNmsp.FlexDataGridColumn();
					mCol9.setHeaderText('Median');
					//mCol9.setDataField(('opmedian3year') + "");

					if ($scope.tab == 1) {
						mCol9.setDataField(('opmedian3year') + "");
					} else {
						mCol9.setDataField(('npmedian3year') + "");
					}

					mCol9.setStyle("textAlign", "right");
					mCol9.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol9.columnWidthMode = "fixed";
					mCol9.Width = "90";
					allCols.push(mCol9);

					var mCol10 = new flexiciousNmsp.FlexDataGridColumn();
					mCol10.setHeaderText('Maximum');
					//mCol10.setDataField(('opMax3year') + "");
					if ($scope.tab == 1) {
						mCol10.setDataField(('opMax3year') + "");
					} else {
						mCol10.setDataField(('npMax3year') + "");
					}

					mCol10.setStyle("textAlign", "right");
					mCol10.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol10.columnWidthMode = "fixed";
					mCol10.Width = "90";
					allCols.push(mCol10);

					var mCol11 = new flexiciousNmsp.FlexDataGridColumn();
					mCol11.setHeaderText('Minimum');
					//mCol11.setDataField(('opMin3tyear') + "");
					if ($scope.tab == 1) {
						mCol11.setDataField(('opMin3tyear') + "");
					} else {
						mCol11.setDataField(('npMin3tyear') + "");
					}

					mCol11.setStyle("textAlign", "right");
					mCol11.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol11.columnWidthMode = "fixed";
					mCol11.Width = "90";

					allCols.push(mCol11);
					ycg.setColumns(allCols);

				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//	mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Median');
					//	mCol4.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opmedin2year') + "");
					} else {
						mCol4.setDataField(('npmedin2year') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[2] + " (%)");

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Median');
					//	mCol5.setDataField(('opmedian3year') + "");
					if ($scope.tab == 1) {
						mCol5.setDataField(('opmedian3year') + "");
					} else {
						mCol5.setDataField(('npmedian3year') + "");
					}
					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);
				}

			}

			if (years.length == 2) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");
					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//mCol3.setDataField(('opmedianlatestyear') + "");

					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//mCol4.setDataField(('opMaxlatestyear') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol6 = new flexiciousNmsp.FlexDataGridColumn();
					mCol6.setHeaderText('Median');
					//	mCol6.setDataField(('opmedin2year') + "");

					if ($scope.tab == 1) {
						mCol6.setDataField(('opmedin2year') + "");
					} else {
						mCol6.setDataField(('npmedin2year') + "");
					}

					mCol6.setStyle("textAlign", "right");
					mCol6.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol6.columnWidthMode = "fixed";
					mCol6.Width = "90";
					allCols.push(mCol6);

					var mCol7 = new flexiciousNmsp.FlexDataGridColumn();
					mCol7.setHeaderText('Maximum');
					//	mCol7.setDataField(('opMax2year') + "");

					if ($scope.tab == 1) {
						mCol7.setDataField(('opMax2year') + "");
					} else {
						mCol7.setDataField(('npMax2year') + "");
					}

					mCol7.setStyle("textAlign", "right");
					mCol7.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol7.columnWidthMode = "fixed";
					mCol7.Width = "90";
					allCols.push(mCol7);

					var mCol8 = new flexiciousNmsp.FlexDataGridColumn();
					mCol8.setHeaderText('Minimum');
					//	mCol8.setDataField(('opMin2tyear') + "");
					if ($scope.tab == 1) {
						mCol8.setDataField(('opMin2tyear') + "");
					} else {
						mCol8.setDataField(('npMin2tyear') + "");
					}

					mCol8.setStyle("textAlign", "right");
					mCol8.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol8.columnWidthMode = "fixed";
					mCol8.Width = "90";
					allCols.push(mCol8);
					ycg.setColumns(allCols);
				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//		mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[1] + " (%)");

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Median');
					//	mCol4.setDataField(('opmedin2year') + "");
					if ($scope.tab == 1) {
						mCol4.setDataField(('opmedin2year') + "");
					} else {
						mCol4.setDataField(('npmedin2year') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);
					ycg.setColumns(allCols);
				}

			}
			if (years.length == 1) {

				if ($scope.Median == "all") {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//mCol3.setDataField(('opmedianlatestyear') + "");
					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}

					mCol3.setStyle("textAlign", "right");
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);

					var mCol4 = new flexiciousNmsp.FlexDataGridColumn();
					mCol4.setHeaderText('Maximum');
					//	mCol4.setDataField(('opMaxlatestyear') + "");

					if ($scope.tab == 1) {
						mCol4.setDataField(('opMaxlatestyear') + "");
					} else {
						mCol4.setDataField(('npMaxlatestyear') + "");
					}

					mCol4.setStyle("textAlign", "right");
					mCol4.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol4.columnWidthMode = "fixed";
					mCol4.Width = "90";
					allCols.push(mCol4);

					var mCol5 = new flexiciousNmsp.FlexDataGridColumn();
					mCol5.setHeaderText('Minimum');
					//mCol5.setDataField(('opMinlatestyear') + "");

					if ($scope.tab == 1) {
						mCol5.setDataField(('opMinlatestyear') + "");
					} else {
						mCol5.setDataField(('npMinlatestyear') + "");
					}

					mCol5.setStyle("textAlign", "right");
					mCol5.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol5.columnWidthMode = "fixed";
					mCol5.Width = "90";
					allCols.push(mCol5);
					ycg.setColumns(allCols);
				} else {

					var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
					var allCols = [];
					gridCgs.push(ycg);
					ycg.setHeaderText(years[0] + " (%)");

					var mCol3 = new flexiciousNmsp.FlexDataGridColumn();
					mCol3.setHeaderText('Median');
					//	mCol3.setDataField(('opmedianlatestyear') + "");

					if ($scope.tab == 1) {
						mCol3.setDataField(('opmedianlatestyear') + "");
					} else {
						mCol3.setDataField(('npmedianlatestyear') + "");
					}
					
					
					if($scope.Median != "all" && years.length == 1)
					{
						mCol3.setStyle("textAlign", "center");
					}else
						{
						mCol3.setStyle("textAlign", "right");
						}
					mCol3.headerAlign = "center";
					//	mCol1.columnWidthMode = "fitToContent";
					mCol3.columnWidthMode = "fixed";
					mCol3.Width = "90";
					allCols.push(mCol3);
					ycg.setColumns(allCols);

				}

			}
			prodgrid.getColumnLevel().setGroupedColumns(gridCgs);
			prodgrid.rebuild();

			$timeout(function() {
				prodgrid.expandAll();
			}, 10);

			prodgrid.validateNow();

		}

		$scope.buildGridoperatingMargin = function() {

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridforoperatingmargin = "Operating Income - Range :"
					+ $scope.filterData.salesTurnoverFrom + "-"
					+ $scope.filterData.salesTurnoverTo + " Crore , "
					+ $scope.locationnameinop;
			ycgmain.setHeaderText(gridforoperatingmargin);
			//	ycgmain.height = 30;

			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();

			if ($scope.selectedType == 'PRODUCT') {
				mCol1.setHeaderText("NIC Code");
				mCol1.setDataField("1");
			} else {
				mCol1.setHeaderText("Industry");
				mCol1.setDataField("0");
			}

			//mCol1.setDataField("1");
			mCol1.headerAlign = "center";
			
			if($scope.Median != "all" && years.length == 1)
				{
				mCol1.setColumnWidthMode= "fixed";
				mCol1.Width="400";
				
				}else
					{
					mCol1.setColumnWidthMode("fitToContent");
					}
			
			
		
			
			allheadCols.push(mCol1);

			if ($scope.selectedType == 'PRODUCT') {
				mCol.setHeaderText("Product");
				mCol.setDataField("0");
			} else {
				mCol.setHeaderText("Segment");
				mCol.setDataField("1");
			}

			mCol.headerAlign = "center";
		//	mCol.setColumnWidthMode("fitToContent");
			
			if($scope.Median != "all" && years.length == 1)
			{
				mCol.setColumnWidthMode= "fixed";
				mCol.Width="400";
			
			}else
				{
				mCol.setColumnWidthMode("fitToContent");
				}

			allheadCols.push(mCol);


			ycgmain.setColumns(allheadCols);
			var k = 2;
			for (var i = 0; i < years.length; i++) {
				var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
				gridCgs.push(ycg);
				ycg.setHeaderText(years[i] + " (%)");
				var allCols = [];

				if ($scope.Median == "all") {
					col = [ "Median", "Maximum", "Minimum" ];
				} else {
					col = [ "Median" ];
				}
				for (var j = 0; j < col.length; j++) {
					var mCol1 = new flexiciousNmsp.FlexDataGridColumn();
					mCol1.setHeaderText(col[j]);
					mCol1.setDataField((k) + "");
					if($scope.Median != "all" && years.length == 1)
						{
						mCol1.setStyle("textAlign", "center");
						}else
							{
							mCol1.setStyle("textAlign", "right");
							}
				
					mCol1.headerAlign = "center";
					mCol1.columnWidthMode = "fitToContent";
				//	mCol1.columnWidthMode = "fixed";
				//	mCol1.Width = "100";
					allCols.push(mCol1);
					k++
				}
				ycg.setColumns(allCols);
			}
			grid.getColumnLevel().setGroupedColumns(gridCgs);
			grid.rebuild();
			grid.validateNow();

		}

		$scope.buildGridnetMargin = function() {

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var gridfornetmargin = "Net Margin - Size Range :"
					+ $scope.filterData.salesTurnoverFrom + "-"
					+ $scope.filterData.salesTurnoverTo + " Crore , "
					+ $scope.locationnameinop;
			ycgmain.setHeaderText(gridfornetmargin);

			var allheadCols = [];

			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();

			if ($scope.selectedType == 'PRODUCT') {
				mCol1.setHeaderText("Product Code");
				mCol1.setDataField("1");
			} else {
				mCol1.setHeaderText("Industry");
				mCol1.setDataField("0");
			}

			//mCol1.setDataField("1");
			mCol1.headerAlign = "center";
			//mCol1.setColumnWidthMode("fitToContent");
			if($scope.Median != "all" && years.length == 1)
			{
				mCol1.setColumnWidthMode= "fixed";
				mCol1.Width="400";
			
			}else
				{
				mCol1.setColumnWidthMode("fitToContent");
				}
			//mCol.setWidth(450);
			allheadCols.push(mCol1);

			var mCol = new flexiciousNmsp.FlexDataGridColumn();

			if ($scope.selectedType == 'PRODUCT') {
				mCol.setHeaderText("Product");
				mCol.setDataField("0");
			} else {
				mCol.setHeaderText("Segment");
				mCol.setDataField("1");
			}


			mCol.headerAlign = "center";

		//	mCol.setColumnWidthMode("fitToContent");
			if($scope.Median != "all" && years.length == 1)
			{
				mCol.setColumnWidthMode= "fixed";
				mCol.Width="400";
			
			}else
				{
				mCol.setColumnWidthMode("fitToContent");
				}

			allheadCols.push(mCol);

			ycgmain.setColumns(allheadCols);
			var k = 2;
			for (var i = 0; i < years.length; i++) {
				var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
				gridCgs.push(ycg);
				ycg.setHeaderText(years[i] + " (%)");
				var allCols = [];

				if ($scope.Median == "all") {
					col = [ "Median", "Maximum", "Minimum" ];
				} else {
					col = [ "Median" ];
				}
				for (var j = 0; j < col.length; j++) {
					var mCol1 = new flexiciousNmsp.FlexDataGridColumn();
					mCol1.setHeaderText(col[j]);
					mCol1.setDataField((k) + "");
					//mCol1.setStyle("textAlign", "right");
					if($scope.Median != "all" && years.length == 1)
					{
					mCol1.setStyle("textAlign", "center");
					}else
						{
						mCol1.setStyle("textAlign", "right");
						}
					mCol1.headerAlign = "center";
					mCol1.columnWidthMode = "fitToContent";
					allCols.push(mCol1);
					k++
				}
				ycg.setColumns(allCols);
			}

			netgrid.getColumnLevel().setGroupedColumns(gridCgs);
			netgrid.rebuild();
			netgrid.validateNow();

		}

		$scope.setTab = function(tabId) {
			$scope.tab = tabId;

			if ($scope.tab == 2) {

				if ($scope.selectedType == 'INDUSTRY') {
					$scope.gridOptionssmeOutputnetmargin = {
						dataProvider : dat.netMargin,
						styles : flexiciousNmsp.UIUtils
								.getThemeById('officeblue').styles,
						delegate : $scope
					};
					$timeout(function() {
						$scope.buildGridnetMargin();
					}, 100);
				} else {
					$scope.gridProductDataNetmargin = {
						dataProvider : $scope.printProddatanp,
						styles : flexiciousNmsp.UIUtils
								.getThemeById('officeblue').styles,
						delegate : $scope
					};
					$timeout(function() {
						if (netprodgrid != null) {
							$scope.buildNetGridProduct();
						}
					}, 100);
				}

			} else if ($scope.tab == 1) {

				if ($scope.selectedType == 'INDUSTRY') {
					$scope.gridOptionssmeOutput = {
						dataProvider : dat.operatingMargin,
						styles : flexiciousNmsp.UIUtils
								.getThemeById('officeblue').styles,
						delegate : $scope
					};
					$timeout(function() {
						$scope.buildGridoperatingMargin();
					}, 100);
				} else {
					$scope.gridProductDatamargin = {
						dataProvider : $scope.printProddataop,
						styles : flexiciousNmsp.UIUtils
								.getThemeById('officeblue').styles,
						delegate : $scope
					};
					$timeout(function() {
						if (prodgrid != null) {
							$scope.buildOperatingGridProduct();
						}
					}, 100);
				}

			}

		};

		$scope.isSetData = function(tabId) {
			return $scope.tab === tabId;
		};

		$scope.resetData = function(name) {
			$scope.showResult = false;
			$scope.novalue = false;
			$scope.nomarginetype = false;
			$scope.noYear = false;
			$scope.outOfRange = false;
			
			$scope.nosegdata = false;
			$scope.nolocdata = false;
			$scope.noinddata = false;

			$scope.filterData.salesTurnoverFrom = '';
			$scope.filterData.salesTurnoverTo = '';
			$scope.selectedranges = [];

			$scope.industryall = false;
			$scope.selectAllflagloc = false;
			$scope.selectAllflagprod = false;
			$scope.filterData.op = ''
			$('#median').prop('checked', false);
			$('#all').prop('checked', false);
			$scope.Median = '';
			$scope.setSelectedType('INDUSTRY')
			$scope.selectedIndustries = [];
			$scope.selectedLocations = [];
			if ($scope.selectedType == 'INDUSTRY') {
				for (var i = 0; i < $scope.sampleSegmentdata.length; i++) {
					$scope.sampleSegmentdata[i].chkval = false;
				}
				$scope.selectedsegmentsfinal=[];
			}
			
			indfiltervaluchanged = false ;
			prodfiltervaluchanged = false ;
			 locfiltervaluchanged = false ;

			if (grid != null) {
				grid.clearSelection();

			}
			if (netgrid != null) {
				netgrid.clearSelection();
			}
			if (locgri != null) {
				locgri.collapseAll();
				locgri.clearSelection();
				locgri.clearAllFilters();
			}
			if (prodgri != null) {
				prodgri.collapseAll();
				prodgri.clearSelection();
				prodgri.clearAllFilters();
			}
			if (indgri != null) {
				indgri.collapseAll();
				indgri.clearSelection();
				indgri.clearAllFilters();
			}
			$scope.selectedLocations = [];
			$scope.selectedProducts = [];
			$scope.selectedIndustries = [];

			$scope.badgeStringProd = '';
			$scope.badgeStringInd = '';
			$scope.badgeStringLoc = '';

			 locfiltervaluchanged = false ;
			 firstcharloc = '';
			 indfiltervaluchanged = false ;
			 firstcharind = '';
		     prodfiltervaluchanged = false ;
			 firstcharprod = '';
			 locfiltervaluchanged = false ;
			 firstcharloc = '';

			arrayind = [];
			arrayprod = [];
			arrayloc = [];
			$scope.categories = [];
			if ($scope.userSectionData['SME Margin.SME Margin for 3 years'] == 'Y') {

				$scope.categories = [ {

					"name" : $scope.year,
					"id" : $scope.year,
					"flg" : 'Y'
				}, {
					"name" : $scope.previousYearData,
					"id" : $scope.previousYearData,
					"flg" : 'Y'
				}, {
					"name" : $scope.lastyearData,
					"id" : $scope.lastyearData,
					"flg" : 'Y'
				} ];
			}

			else if ($scope.userSectionData['SME Margin.SME Margin for 2 years'] == 'Y') {
				$scope.categories = [ {

					"name" : $scope.year,
					"id" : $scope.year,
					"flg" : 'Y'
				}, {
					"name" : $scope.previousYearData,
					"id" : $scope.previousYearData,
					"flg" : 'Y'
				}, {
					"name" : $scope.lastyearData,
					"id" : $scope.lastyearData,
					"flg" : 'N'
				} ];
			}

			else if ($scope.userSectionData['SME Margin.SME Margin for latest year'] == 'Y') {
				$scope.categories = [ {

					"name" : $scope.year,
					"id" : $scope.year,
					"flg" : 'Y'
				}, {
					"name" : $scope.previousYearData,
					"id" : $scope.previousYearData,
					"flg" : 'N'
				}, {
					"name" : $scope.lastyearData,
					"id" : $scope.lastyearData,
					"flg" : 'N'
				} ];
			}

			var yearObject = {};
			yearObject[currentYear] = false;

			$scope.filterData = {
				operatingMargin : false,
				netMargin : false,
				Median : false
			}
			$scope.filterData["ids"] = yearObject;
			$scope.outOfRange = false;
			
		}
		
		
		$scope.getCountForReportGenerate = function(){
			
			SmeMarginsService.getCountOfReport().then(function(response){
				
				$scope.totalCountOfReport = response;
				
				
			});
		}
		
		$scope.getCurrentReportCount = function(){
			
			$scope.getCountForReportGenerate();
		}
		
		
		$scope.getCountForReportGenerate();
	}
})();

